var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,2A19,19,0,0,0,13,21V32H12a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h1.09A6,6,0,0,0,18,44.91V47H17a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h1v5h2V57h1a1,1,0,0,0,1-1V48a1,1,0,0,0-1-1H20V44.91A6,6,0,0,0,24.91,40H39.09A6,6,0,0,0,44,44.91V47H43a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h1v5h2V57h1a1,1,0,0,0,1-1V48a1,1,0,0,0-1-1H46V44.91A6,6,0,0,0,50.91,40H52a1,1,0,0,0,1-1V33a1,1,0,0,0-1-1H51V21A19,19,0,0,0,32,2ZM15,21a17,17,0,0,1,34,0V32H40V27a1,1,0,0,0-1-1H38V13a1,1,0,0,0-.44-.83,1,1,0,0,0-.93-.1L32,13.92l-4.63-1.85a1,1,0,0,0-.93.1A1,1,0,0,0,26,13V26H25a1,1,0,0,0-1,1v5H15Zm23,7v4H26V28ZM28,26V14.48l3,1.2V26Zm5,0V15.68l3-1.2V26ZM20,55H18V49h2ZM19,43a4,4,0,0,1-3.86-3h7.72A4,4,0,0,1,19,43ZM46,55H44V49h2ZM45,43a4,4,0,0,1-3.86-3h7.72A4,4,0,0,1,45,43Zm6-5H13V34H51Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParts);
export default __webpack_public_path__ + "static/media/parts.01778c00536744c66c9832192c59dc56.svg";
export { ForwardRef as ReactComponent };